import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { fetchItems, IIsp } from '@/api/isps'

export const useIspsStore = defineStore('isps', () => {
  const items = ref<IIsp[]>([])
  const listLoading = ref(false)
  const error = ref<string | null>(null)

  const sorted = computed(() => items.value)

  const GetItems = async () => {
    if (items.value.length > 0) return items.value

    listLoading.value = true
    error.value = null
    try {
      const response = await fetchItems()
      items.value = response.data
      return items.value
    } catch (e: any) {
      console.error(e)
      error.value = e.toString()
      return []
    } finally {
      listLoading.value = false
    }
  }

  return {
    items,
    sorted,
    listLoading,
    error,
    GetItems
  }
})
